import { render, staticRenderFns } from "./ActiveSign.vue?vue&type=template&id=0113a4d8&"
import script from "./ActiveSign.vue?vue&type=script&lang=js&"
export * from "./ActiveSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0113a4d8')) {
      api.createRecord('0113a4d8', component.options)
    } else {
      api.reload('0113a4d8', component.options)
    }
    module.hot.accept("./ActiveSign.vue?vue&type=template&id=0113a4d8&", function () {
      api.rerender('0113a4d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/simple/signapiExterno/ActiveSign.vue"
export default component.exports